export default "__VITE_ASSET__PW$UpF6f__"